"use client";

import { useLayoutEffect, useState } from "react";

function applyBannerHeight(height: number) {
  document.documentElement.style.setProperty("--promo-banner-height", `${height}px`);
}

/**
 * Keeps `--promo-banner-height` in sync so editor shells can size to
 * `100dvh - banner` instead of claiming the full viewport and scrolling
 * the sale banner off-screen on load.
 */
export function usePromoBannerHeight(): number {
  const [bannerHeight, setBannerHeight] = useState(0);

  useLayoutEffect(() => {
    const slot = document.querySelector("[data-promo-banner-slot]") as HTMLElement | null;
    if (!slot) {
      applyBannerHeight(0);
      return;
    }

    const measure = () => {
      const height = slot.offsetHeight;
      setBannerHeight(height);
      applyBannerHeight(height);
    };

    measure();
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(slot);
    return () => resizeObserver.disconnect();
  }, []);

  return bannerHeight;
}
